import { render, staticRenderFns } from "./InfoGraphic.vue?vue&type=template&id=2946f52e&"
import script from "./InfoGraphic.vue?vue&type=script&lang=js&"
export * from "./InfoGraphic.vue?vue&type=script&lang=js&"
import style0 from "./InfoGraphic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports